import type { ApplicationEditions } from '@jira/platform__application-editions/src/edition.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import TopNavSettingsMenuQuery from '@atlassian/jira-relay/src/__generated__/TopNavSettingsMenuQuery.graphql.ts';
import { fg } from '@atlassian/jira-feature-gating';

type SettingsMenuEntryPointParams = {
	cloudId: string;
	isAdmin: boolean;
	appEditions?: ApplicationEditions;
};

export const settingsMenuEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-top-nav-settings-menu" */ './TopNavSettingsMenu').then(
			({ TopNavSettingsMenu }) => TopNavSettingsMenu,
		),
	),
	getPreloadProps: ({ cloudId, isAdmin, appEditions }: SettingsMenuEntryPointParams) => ({
		queries: {
			topNavSettingsMenuQuery: {
				options: { fetchPolicy: 'store-and-network' as const },
				parameters: TopNavSettingsMenuQuery,
				variables: {
					cloudId,
					// We can skip the permission check when:
					// 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
					// 2. Upsell is enabled (because upsell is only available to admins), or
					// 3. The main custom onboarding hub gate is disabled (because the custom onboarding feature won't be visible to anyone), or
					// 4. The delegated admin gate is disabled (because only admins would be able to view the feature)
					skipDelegatedAdminCheck:
						isAdmin ||
						(appEditions?.software !== 'PREMIUM_EDITION' &&
							fg('restrict-custom-onboarding-to-premium-tier')) ||
						!fg('jira-onboarding-hub-gate') ||
						!fg('jira-delegated-custom-onboarding'),
				},
			},
		},
	}),
});
